export interface ResumePosition {
  moduleSlug: string;
  slideIndex: number;
}

function storageKey(userId: string, courseId: string) {
  return `elearning_resume_${userId}_${courseId}`;
}

export function readResume(userId: string, courseId: string): ResumePosition | null {
  try {
    const raw = localStorage.getItem(storageKey(userId, courseId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ResumePosition;
    if (!parsed.moduleSlug || !Number.isInteger(parsed.slideIndex) || parsed.slideIndex < 0) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function writeResume(userId: string, courseId: string, position: ResumePosition) {
  localStorage.setItem(storageKey(userId, courseId), JSON.stringify(position));
}

export function clearResume(userId: string, courseId: string) {
  localStorage.removeItem(storageKey(userId, courseId));
}
